import { motion } from "framer-motion";
import { memo } from "react";
import { LazyLoadImage } from "../index";

export const PageLoader: React.FC<{
  image?: string;
  icon?: JSX.Element;
  className?: string;
}> = ({ image, icon, className }) => {

  return (
    <motion.div
      animate={{
        scale: [1, 1.1, 1], // Scale values to animate
        opacity: [1, 0.5, 1], // Opacity values to animate
      }}
      transition={{
        duration: 3, // Duration of each animation cycle
        repeat: Infinity, // Repeat the animation indefinitely
      }}
      className="flex justify-center items-center h-screen"
    >
      {image && (
        <LazyLoadImage src={image} alt="Payxpress" className={className} />
      )}
      {icon}
    </motion.div>
  );
};

export const MemoizedPageLoader = memo(PageLoader);
